import React from 'react';

import { Box, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { BankDocument, ComponentInfo } from '@components';
import { rem } from '@helpers';

import { DocCardSkeleton } from './block';
import { useTermsAndConditionsHelper } from './termsAndConditions.helper';

export const TermsAndConditionsPlaceholder: React.FC = () => {
	const { resources, retrieveBankDocumentReference } = useTermsAndConditionsHelper();

	return (
		<ComponentInfo name="TermsAndConditionsPlaceholder" type="placeholder">
			<Box styles={{ marginBottom: rem(36) }}>
				<Typography appearance="headline-200-02">{resources.title}</Typography>
			</Box>
			{retrieveBankDocumentReference === undefined ? <DocCardSkeleton /> : <BankDocument />}
		</ComponentInfo>
	);
};
